var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppsSharpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 2.25H2.625C2.41789 2.25 2.25 2.41789 2.25 2.625V7.125C2.25 7.33211 2.41789 7.5 2.625 7.5H7.125C7.33211 7.5 7.5 7.33211 7.5 7.125V2.625C7.5 2.41789 7.33211 2.25 7.125 2.25Z",
    fill: "#CA5050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.25H9.75C9.54289 2.25 9.375 2.41789 9.375 2.625V7.125C9.375 7.33211 9.54289 7.5 9.75 7.5H14.25C14.4571 7.5 14.625 7.33211 14.625 7.125V2.625C14.625 2.41789 14.4571 2.25 14.25 2.25Z",
    fill: "#CA5050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 2.25H16.875C16.6679 2.25 16.5 2.41789 16.5 2.625V7.125C16.5 7.33211 16.6679 7.5 16.875 7.5H21.375C21.5821 7.5 21.75 7.33211 21.75 7.125V2.625C21.75 2.41789 21.5821 2.25 21.375 2.25Z",
    fill: "#CA5050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 9.375H2.625C2.41789 9.375 2.25 9.54289 2.25 9.75V14.25C2.25 14.4571 2.41789 14.625 2.625 14.625H7.125C7.33211 14.625 7.5 14.4571 7.5 14.25V9.75C7.5 9.54289 7.33211 9.375 7.125 9.375Z",
    fill: "#CA5050"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.375H9.75C9.54289 9.375 9.375 9.54289 9.375 9.75V14.25C9.375 14.4571 9.54289 14.625 9.75 14.625H14.25C14.4571 14.625 14.625 14.4571 14.625 14.25V9.75C14.625 9.54289 14.4571 9.375 14.25 9.375Z",
    fill: "#CA5050"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 9.375H16.875C16.6679 9.375 16.5 9.54289 16.5 9.75V14.25C16.5 14.4571 16.6679 14.625 16.875 14.625H21.375C21.5821 14.625 21.75 14.4571 21.75 14.25V9.75C21.75 9.54289 21.5821 9.375 21.375 9.375Z",
    fill: "#CA5050"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 16.5H2.625C2.41789 16.5 2.25 16.6679 2.25 16.875V21.375C2.25 21.5821 2.41789 21.75 2.625 21.75H7.125C7.33211 21.75 7.5 21.5821 7.5 21.375V16.875C7.5 16.6679 7.33211 16.5 7.125 16.5Z",
    fill: "#CA5050"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 16.5H9.75C9.54289 16.5 9.375 16.6679 9.375 16.875V21.375C9.375 21.5821 9.54289 21.75 9.75 21.75H14.25C14.4571 21.75 14.625 21.5821 14.625 21.375V16.875C14.625 16.6679 14.4571 16.5 14.25 16.5Z",
    fill: "#CA5050"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 16.5H16.875C16.6679 16.5 16.5 16.6679 16.5 16.875V21.375C16.5 21.5821 16.6679 21.75 16.875 21.75H21.375C21.5821 21.75 21.75 21.5821 21.75 21.375V16.875C21.75 16.6679 21.5821 16.5 21.375 16.5Z",
    fill: "#CA5050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsSharpIcon);
export default __webpack_public_path__ + "static/media/apps-sharp-icon.ed8e426418fc914e42219f6bd13c2876.svg";
export { ForwardRef as ReactComponent };